import { FC, useEffect, useRef, useState } from 'react';
import { Box, Button, Chip, TextField, Tooltip, Typography } from '@mui/material';
import styles from 'shared/modal-new/ModalNew.module.css';
import ModalWidget from 'widgets/modal/Modal';
import ChatAnimation from 'shared/chat-animation/ChatAnimation';

interface IModalNew {
    handleCloseModal: () => void;
}

export const ModalNew: FC<IModalNew> = ({handleCloseModal}) => {
    const [open, setOpen] = useState(true);
    const handleClose = () => {
        setOpen(false);
        handleCloseModal();
    };

    return (
        <ModalWidget
            open={open}
            handleClose={handleClose}
            title=""
            closeIconPosition="right"
            onCancel={handleClose}
            widthProps={350}
        >
            <Box className={styles.modalInfo}>
                <ChatAnimation />
                <h4>В разделе <span>«Заявки»</span> появился чат для общения по заявке!</h4>
            </Box>
        </ModalWidget>
    );
};

export default ModalNew;
